import React from 'react';
import {
    copyLink
} from "../../../../util/UrlUtil";
import {Grid, Tooltip} from "@mui/material";
import {BodyText, H6Text} from "../../../../styles/AvantTypography";
import FileCopyIcon from "@material-ui/icons/FileCopy";

/**
 * Links to the `AvantProctorPage` associated with this login test code.
 * An individual test taker can access this link and register for an exam test.
 * On production, they will receive an email with a scheduling url and instructions for the exam.
 */
export function RegistrationLink({url}: {url: string}){
    return (
        <Grid style={{maxWidth: "18rem"}} item={true}>
            <H6Text>Self-Register Link:</H6Text>
            <BodyText style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>{url}</BodyText>
            <Tooltip title="Copy link">
                <FileCopyIcon style={{ color: "#007bff", marginRight: "30px" }}
                              onClick={() => {
                                  copyLink(url)
                              }}
                />
            </Tooltip>
        </Grid>
    )
}